import React from 'react';
import InspectionCard from './InspectionCard';

const InspectionsList = ({ inspections }) => {
   return (
      <div className="border rounded-lg bg-card p-6">
         {/*  make scrollbar thin and modern */}
         <div className="max-h-[650px] overflow-y-auto space-y-3 pr-6 [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-gray-300 [&::-webkit-scrollbar-thumb]:rounded-full">
            {inspections.map(inspection => (
               <InspectionCard
                  key={inspection.id}
                  inspection={inspection}
               />
            ))}
         </div>
      </div>
   );
};

export default InspectionsList;
